import { isEqualWith, isFunction, isEqual } from 'lodash-es';
import { F as FocusSource } from './p-462429f0.js';

function getDataProps(props, nodeName) {
    const dataProps = {};
    Object.keys(props).forEach((key) => {
        if (!(typeof props[key] === 'string' ||
            typeof props[key] === 'number' ||
            typeof props[key] === 'boolean') ||
            key === 'contentEditable' ||
            key === 'contentEditable' ||
            key === 'class' ||
            key === 'style' ||
            key === 'title')
            return;
        if (props[key] != null) {
            dataProps[`data-bxf-${key.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`)}`] = String(props[key]);
        }
    });
    if (nodeName) {
        dataProps['data-bxf-node-name'] = nodeName;
    }
    return dataProps;
}

function getNodeByBxfNodeName(bxfNodeName, host) {
    const query = `[data-bxf-node-name="${bxfNodeName}"]`;
    const shadowQuery = host.shadowRoot && host.shadowRoot.querySelector(query);
    return host.querySelector(query) || shadowQuery;
}

function getState(context = this) {
    if (context === this) {
        return this;
    }
    return this[context];
}

let listeners = [];
const removeGlobalEventListener = (elm, type, listener, options) => {
    // Find the old listener
    const oldListener = listeners.find((_listener) => isEqualWith(listener, _listener.handler, (l1, l2) => {
        if (isFunction(l1) && isFunction(l2)) {
            return l1.toString() === l2.toString();
        }
        return isEqual(l1, l2);
    }) &&
        isEqual(_listener.options, options) &&
        isEqual(_listener.type, type));
    if (oldListener) {
        // Remove the old listener from element
        elm.removeEventListener(oldListener.type, oldListener.handler, oldListener.options);
        // Remove the old listener form the saved array
        listeners = listeners.filter((item) => item !== oldListener);
    }
};
const addGlobalEventListener = (elm, type, listener, options) => {
    // Remoeve the old listener
    removeGlobalEventListener(elm, type, listener, options);
    // Add new event listener to element
    elm.addEventListener(type, listener, options);
    // Add new event listener to saved array
    listeners.push({ type, handler: listener, options });
};

async function setState(state, context = this) {
    setTimeout(() => {
        if (context === this) {
            Object.keys(state).forEach((key) => (this[key] = state[key]));
        }
        else {
            this[context] = { ...this[context], ...state };
        }
        Promise.resolve();
    });
}

function withState(state, stateName, context) {
    const _state = {
        ...context[stateName],
        ...state,
        setState: setState.bind(context),
        getState: getState.bind(context),
        stateName,
    };
    return _state;
}

/**
 * Find the closest ancestor of a root that matches a given CSS selector, traversing the shadow dom.
 *
 * @export
 * @param {string} selector
 * @param {*} _root
 * @returns {Element}
 */
function closestShadowDom(selector, root) {
    let _root = root;
    if (!_root || _root === document || _root === window) {
        return null;
    }
    if (_root.assignedSlot) {
        _root = _root.assignedSlot;
    }
    const match = _root.closest(selector);
    return match || closestShadowDom(selector, _root.getRootNode().host);
}

function getFocusSource(event, keepMouseFocus) {
    if (!keepMouseFocus) {
        return event.pointerType === FocusSource.Touch
            ? FocusSource.Touch
            : FocusSource.Mouse;
    }
    return FocusSource.Keyboard;
}

export { getNodeByBxfNodeName as a, getState as b, addGlobalEventListener as c, closestShadowDom as d, getFocusSource as e, getDataProps as g, removeGlobalEventListener as r, setState as s, withState as w };
